'use strict';

function timeUtilsController() {
  'ngInject';

  const vm = {};

  vm.addSeconds = function (seconds) {
    const now = new Date();
    return new Date(now.getTime() + (seconds * 1000));
  }

  return vm;
}

export default timeUtilsController;
